import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/common.scss'
import 'normalize.css'
import 'quill/dist/quill.snow.css'
import 'highlight.js/styles/github-gist.css'
import 'normalize.css'
import smoothscroll from 'smoothscroll-polyfill';
import mixin from '@/assets/js/mixins/index.js'
import vod from '@/assets/js/mixins/vod.js'


smoothscroll.polyfill();
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.mixin(mixin)
Vue.mixin(vod)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
